import { render, staticRenderFns } from "./AssetTransferDetail.vue?vue&type=template&id=70b0fc54&"
import script from "./AssetTransferDetail.vue?vue&type=script&lang=ts&"
export * from "./AssetTransferDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b0fc54')) {
      api.createRecord('70b0fc54', component.options)
    } else {
      api.reload('70b0fc54', component.options)
    }
    module.hot.accept("./AssetTransferDetail.vue?vue&type=template&id=70b0fc54&", function () {
      api.rerender('70b0fc54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Transactions/AssetTransferDetail.vue"
export default component.exports